module.exports = __webpack_public_path__ + "img/dcmm_7.62434c37.png";